module.exports = __webpack_public_path__ + "img/logo.097a92db.png";